import { gql } from "apollo-angular";

const GET_CROSS_UPLOAD_REQUESTS= gql`
query getCrossUploadRequests($uploadRequestId: Long!){
  crossUploadRequests(
    uploadRequestId: $uploadRequestId
  ) {
    id,
    rowNumber,
    action,
    uploadStatus
    fromProductResolution{
      catalogNumber,
      description,
      sellerName,
      potentialMatches{
        id,
        catalogNumber,
        description,
      },
      resolvedProduct{
        catalogNumber,
        description,
        id
      }
    },
    toProductResolution{
      catalogNumber,
      description,
      sellerName,
      potentialMatches{
        id,
        catalogNumber,
        description,
      },
      resolvedProduct{
        catalogNumber,
        description,
        id
      }
    },
    violationSummaries{
      message,
      category{
        message,
        alertLevel,
        eligibleForReview,
      }
    }
  }
}
`;

export default GET_CROSS_UPLOAD_REQUESTS;